import {Pipe, PipeTransform} from '@angular/core';
import {MstMessageService} from '../services/common/mst-message.service';

@Pipe({
    name: 'mstMessage',
})
export class MstMessagePipe implements PipeTransform {
    constructor(
        private mstMessageService: MstMessageService,
    ) {
    }

    transform(id: number = null): string {
        return this.mstMessageService.getMessage(id);
    }
}

@Pipe({
    name: 'mstMessageImpure',
    pure: false,
})
export class MstMessageImpurePipe implements PipeTransform {
    constructor(
        private mstMessageService: MstMessageService,
    ) {
    }

    transform(id: number = null): string {
        return this.mstMessageService.getMessage(id);
    }
}
